import { render, staticRenderFns } from "./dkyj.vue?vue&type=template&id=56826c97&"
import script from "./dkyj.vue?vue&type=script&lang=js&"
export * from "./dkyj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports